module.exports = __webpack_public_path__ + "static/media/LG 17_18sec.89723132.mp3";